
import { RoutingRepository } from '../repositories/RoutingRepository';

export class RoutingService {
  private repository: RoutingRepository;

  constructor() {
    this.repository = RoutingRepository.getInstance();
  }

  public async addRoute(payload: any): Promise<any> {
    return await this.repository.addRoute(payload);
  }

  public async getRoutes(): Promise<any> {
    return await this.repository.getRoutes();
  }

  public async getRouteByInstanceId(instanceId: string): Promise<any> {
    return await this.repository.getRouteByInstanceId(instanceId);
  }

}

// Export singleton instance
export const routingService = new RoutingService();
